//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixin from "@/mixins/index";
import TopHeader from "./components/TopHeader.vue";
import YearTotal from "@/components/YearTotal";
import TeamCard from "./components/TeamCard.vue";
import Combat from "./components/Combat.vue";
import Innovate from "./components/Innovate.vue";
import MemberInfo from "@/components/MemberInfo";
import CustomerFlow from "@/components/CustomerFlow";
import { getOperateData } from "@/api/operate";
import {
  getGroupList,
  getGroupProduct,
  getGroupPosition,
  getGroupRank,
  getCustomerData,
} from "@/api/shop";
import { formatRegionList } from "@/utils/region";
import { formatShopList } from "@/utils/shop";
import { formatProductList } from "./models/product";
export default {
  name: "Shop",
  mixins: [mixin],
  components: {
    TopHeader,
    YearTotal,
    TeamCard,
    Combat,
    Innovate,
    MemberInfo,
    CustomerFlow,
  },
  data() {
    return {
      // 展示大型卡片
      isShowLargeCard: false,
      regionList: [],
      tableData: [],
      groupList: [],
      active: 1,
      shopName: undefined,
      list2: [
        {
          id: 1,
          label: "全店",
          combat: [
            {
              label: "F员工",
              rank: 1,
            },
            {
              label: "W员工",
              rank: 2,
            },
            {
              label: "G员工",
              rank: 3,
            },
            {
              label: "T员工",
              rank: 4,
            },
          ],
        },
        {
          id: 2,
          label: "A班组",
          combat: [
            {
              label: "A员工",
              rank: 1,
            },
            {
              label: "B员工",
              rank: 2,
            },
            {
              label: "C员工",
              rank: 3,
            },
            {
              label: "D员工",
              rank: 4,
            },
          ],
        },
        {
          id: 3,
          label: "B班组",
          combat: [
            {
              label: "C员工",
              rank: 1,
            },
            {
              label: "D员工",
              rank: 2,
            },
            {
              label: "B员工",
              rank: 3,
            },
            {
              label: "A员工",
              rank: 4,
            },
          ],
        },
      ],
    };
  },
  computed: {
    // 当前区域的信息
    currentShopInfo() {
      let list = this.tableData[this.active];
      if (!list) return {};
      return list.find((v) => v.region === this.shopName) || {};
    },
    // 列表数据
    list() {
      return this.groupList[this.active];
    },
  },
  created() {
    // 门店id
    this.shopName = this.$route.params.name;
    if (this.shopName) {
      this.getData();
      this.getList();
      this.getGroupRank();
      this.getCustomerData();
    }
  },
  methods: {
    onChange(index) {
      this.active = index;
    },
    onCityConfirm(region) {
      // this.region = region;
      this.showPicker = false;
      this.shopName = region.name;
      this.getData();
      this.getList();
      this.getGroupRank();
      this.getCustomerData();
    },
    async getData() {
      let data = {
        search: JSON.stringify({ Shop: this.shopName }),
      };
      let rows = await getOperateData(data);
      let { regionList, tableData } = formatRegionList(rows);
      this.regionList = regionList;
      this.region = regionList.find((v) => v.name === this.shopName);
      this.tableData = tableData;
    },
    async getList() {
      let rows = await getGroupList({
        search: JSON.stringify({ Shop: this.shopName }),
      });
      // 定岗*人、缺编*人
      // await getGroupPosition({});
      // 详情数据
      let products = await getGroupProduct({
        search: JSON.stringify({ Shop: this.shopName }),
      });
      let groupList = formatShopList(rows.concat(products));

      // products = formatProductList(products);
      // groupList = groupList.map((v, i) => {
      //   return v.map((item) => {
      //     const product = products[i].find((val) => val.name === item.name);
      //     if (product && product.products) {
      //       return {
      //         ...item,
      //         products: product.products,
      //       };
      //     }
      //     return item;
      //   });
      // });

      this.groupList = groupList;
    },
    async getGroupRank() {
      let rows = await getGroupRank({
        search: JSON.stringify({ Shop: this.shopName }),
      });
    },
    async getCustomerData() {
      let rows = await getCustomerData({
        search: JSON.stringify({ Shop: this.shopName }),
      });
    },
  },
};
